define(["jquery"], function ($) {
    var querystring = require("querystring");
    var reduceParams = function (parameters, defaults, retainNonFalseyDefaults) {
        var filteredParameters = {};

        for (var i in parameters) {
            // don't write falsely values or default values
            if (parameters.hasOwnProperty(i) && parameters[i] && (retainNonFalseyDefaults || !defaults.hasOwnProperty(i) || parameters[i] !== defaults[i])) {
                filteredParameters[i] = parameters[i];
            } else if (filteredParameters.hasOwnProperty(i)) {
                delete filteredParameters[i];
            }
        }

        return filteredParameters;
    };

    return {
        /**
         * Writes the given set of parameters to the page query string.
         *
         * @param {} parameters
         * @returns {}
         */
        write: function (parameters, defaults) {
            var filteredParameters = reduceParams(parameters, defaults);

            var search = querystring.stringify(filteredParameters);
            var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + search;

            var currentSearch = document.location.search.replace("?", "");

            if (currentSearch !== search) {
                if (history.pushState) {
                    window.history.pushState({ path: newUrl }, "", newUrl);
                }
            }

            return newUrl;
        },
        /**
         * Reads the current set of parameters from the page query string.
         * @returns {}
         */
        read: function () {
            var params = querystring.parse();

            // pluses ('+') in the querystring are being re-encoded as %2B; the following keeps spaces encoded as %20.
            $.each(params, function (i, v) {
                if (Array.isArray(v)) {
                    var list = [];
                    $.each(v, function (a, b) {
                        list.push(b.replace(/\+/g, " ").replace(/%2B/g, "+"));
                    });
                    params[i] = list;
                } else {
                    params[i] = v.replace(/\+/g, " ").replace(/%2B/g, "+");
                }
            });

            return params;
        },
        /**
         * Reduces the given parameters object to the minimum necessary.
         * Strips all default and falsey values.
         *
         * @returns {}
         */
        reduceParams: reduceParams
    };
});
